module.exports = __webpack_public_path__ + "img/caution-folder.7989f41.svg";